import { request } from '@/lib/api'

/**
 * Черновик ответа клиенту (тикет #134).
 *
 * Черновик — только текст: отправляют его обычные пути (письмо, мессенджер, ответ на обращение)
 * с тем текстом, что оставил менеджер, и с `draftTaskId`, чтобы сервер записал, правили ли его.
 * Поля ответа сравниваются нестрого (`== null`): пустых полей в JSON нет вовсе (`non_null`).
 */

export type ReplyChannel = 'email' | 'messenger' | 'support'

/** Запись, которую получила модель, под её меткой: договор (`D1`) или запись истории (`S1`). */
export interface ReplyDraftSource {
  label: string
  /** `contract` или вид события ленты (`email`, `call`, `message`, …), `support_message`. */
  kind: string
  recordType: string
  recordId: string
  at?: string | null
  title?: string | null
  /** У договора — его условия так, как их прочитала модель. */
  detail?: string | null
}

export interface ReplyDraft {
  taskId: string
  channel: ReplyChannel
  sourceId: string
  /** `working`, `retrying` (провайдер не ответил, повтор назначен), `failed` (отказ) или `ready`. */
  state: 'working' | 'retrying' | 'failed' | 'ready'
  message?: string | null
  reply?: string | null
  cited?: ReplyDraftSource[] | null
  unknownLabels?: string[] | null
  sources?: ReplyDraftSource[] | null
  /** У клиента есть договоры, которые вам не видны: в черновик они не попали. */
  contractsWithheld: boolean
  /** Базы знаний в CRM нет — всегда false, и экран говорит это вслух. */
  knowledgeBase: boolean
  use?: { sentRefId?: string | null; edited: boolean; sentAt?: string | null } | null
}

export function requestReplyDraft(channel: ReplyChannel, sourceId: string): Promise<ReplyDraft> {
  return request<ReplyDraft>('/ai/reply-drafts', { method: 'POST', body: { channel, sourceId } })
}

export function fetchReplyDraft(taskId: string, signal?: AbortSignal): Promise<ReplyDraft> {
  return request<ReplyDraft>(`/ai/reply-drafts/${taskId}`, { signal })
}
